import { SettingsConfirmationDialog } from '../settings-confirmation-dialog';

export function DeleteTeamDialog({
  name,
  pending,
  error,
  onClose,
  onConfirm,
}: {
  name: string;
  pending: boolean;
  error?: string;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <SettingsConfirmationDialog
      title="Delete team"
      description={
        <>
          Delete {name}? This removes the team and its memberships and skill assignments. The skills themselves and
          organization memberships are kept.
        </>
      }
      confirmLabel="Delete team"
      pendingLabel="Deleting…"
      pending={pending}
      error={error}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
